import { Factory } from '../Factory';
import { Service } from '../Service';
import {Export} from "../../model/exporting/Export";

export class ExportService extends Service<any> {
  constructor(resource: any, rootScope: IRootScope, private configService, resourceWrapperService, exportDownloadService, private httpService, private notificationService) {
    super({resource, rootScope, resourceWrapperService});

    let exportResource = this.resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/export/:id`,
        {id: "@id", projectId: "@projectId"},
        {update: {method: "PUT"}});

      this.itemResource = this.resourceWrapperService.WrapActions(exportResource);

      // ExportComplete / ExportFailed / ExportUpdate are handled in React
      // (src/hooks/useExports -> WebSocketBridge), including their toasts.
    }

    public Replay(exportItem: Export) {
      let url = `${this.configService.getServerBaseUrl()}/project/${exportItem.projectId}/export/${exportItem.id}/replay`;

      return this.httpService.$http({
        method: "POST",
        url: url
      }).success(() => {
        this.notificationService.addSuccess({
          title: "Export Replay started",
          description: "",
          timeout: 2500
        });
      }).error(() => {
        this.notificationService.addError({
          title: "Error Exporting",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });
      });
    }

    public GetExportStatistics(exportItem: Export) {
      let url = `${this.configService.getServerBaseUrl()}/project/${exportItem.projectId}/export/statistics`;

      return this.httpService.$http({
        method: "POST",
        data: exportItem,
        url: url
      });
    }

    protected StartNotification(projectId: string) {
      this.rootScope.$broadcast("ExportService.update", projectId, _.filter(this.items, (i: any) => i.projectId === projectId));
    }
  }


frontendApp.factory("ExportService", ["$resource", "$rootScope", "ConfigService", "ResourceWrapperService", "ExportDownloadService", "HttpService", "NotificationService", Factory.Create(ExportService)]);
